var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('navigation'),_c('v-main',[_c('router-view'),(_vm.loading)?_c('v-container',[_c('v-skeleton-loader',{attrs:{"type":"article"}})],1):_vm._e()],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }